import Result from "@/core/common/Result";

export interface IIniciarVoucherGateway {
  sendDataVisualizacao(
    id: string,
    dataVisualizacao: string
  ): Promise<Result<void>>;
}

export const iniciarVoucherGatewayDI = "iniciarVoucherGatewayDI";
